export function fireGTMEvent(eventName, data = {}) {
    if (typeof window === "undefined") return;
  
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...data,
    });
  }
  